export default {
  WBCI_ADMIN: "ROLE_WBC-WBCI-ADMIN",
  WBCI_VIEWER: "ROLE_WBC-WBCI-VIEWER",
  CLUB_RECIPIENT: "ROLE_WBC-CLUB-RECIPIENT",
  FED_TEAM_ADMIN: "ROLE_WBC-FED-TEAM-ADMIN",
  FED_TEAM_USER: "ROLE_WBC-FED-TEAM-USER",
  TEAM_COORDINATOR: "ROLE_WBC-TEAM-COORDINATOR"
};
